import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { getCurrentUser } from "../services/utilisateurs";
import type { Utilisateur } from "../types/utilisateur";
import "./Dashboard.css";
import logo from "../assets/congelcam-logo.png";

import TableauDeBord from "../components/childuser/TableauDeBord";
import Releves from "../components/childuser/Releves";
import Localisations from "../components/childuser/Localisations";
import Entrepots from "../components/childuser/Entrepots";
import ChambresFroides from "../components/childuser/ChambresFroides";
import GroupesFrigorifiques from "../components/childuser/GroupesFrigorifiques";
import Seuils from "../components/childuser/Seuils";
import Conteneurs from "../components/childuser/Conteneurs";
import Alertes from "../components/childuser/Alertes";

export default function DashboardUser() {
  const [user, setUser] = useState<Utilisateur | null>(null);
  const [activeMenu, setActiveMenu] = useState("Tableau de bord");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("role");
    navigate("/");
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await getCurrentUser();
        setUser(data);
      } catch (err) {
        console.error("Erreur récupération profil :", err);
      }
    };
    fetchUser();
  }, []);

  if (!user) return <p>Chargement...</p>;

  const renderContent = () => {
    switch (activeMenu) {
      case "Tableau de bord":
        return <TableauDeBord />;
      case "Relèves":
        return <Releves />;
      case "Alertes":
        return <Alertes />;
      case "Localisations":
        return <Localisations />;
      case "Entrepôts":
        return <Entrepots />;
      case "Chambres froides":
        return <ChambresFroides />;
      case "Groupes frigorifiques":
        return <GroupesFrigorifiques />;
      case "Seuils":
        return <Seuils />;
      case "Conteneurs":
        return <Conteneurs />;
      default:
        return <p>Sélectionnez un menu</p>;
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar {...user} activeMenu={activeMenu} setActiveMenu={setActiveMenu} onLogout={handleLogout} />
      <main className="dashboard-main">
        <div className="dashboard-header">
          <h1 className="dashboard-title">{activeMenu}</h1>
          <img src={logo} alt="Congelcam Logo" className="dashboard-logo" />
        </div>
        {renderContent()}
      </main>
    </div>
  );
}
